export const ATTENDANCE_MANAGEMENT_PT_BR = {
	attendanceManagement: "Gestão de Atendimento",
	environmentsAndTables: "Ambientes e mesas",
	createAndManageEnvironments:
		"Crie e gerencie ambientes e mesas do seu estabelecimento.",
	searchByTable: "Buscar por mesa",
	statusConfiguration: "Configuração de status",
	filter: "Filtrar por",
	tablesInService: "Mesas em atendimento",
	tablesNeedingAttention: "Mesas que precisam de atenção",
	availableTables: "Mesas disponíveis",
	seeMore: "Ver mais",
	seeAll: "Ver todos",
	selectAll: "Selecionar todos",
	loading: "Carregando...",
	paid: "Pago",
	statusLabel: {
		Available: "Disponível",
		InService: "Em atendimento",
		Paid: "Pago",
		InPayment: "Em pagamento",
		Blocked: "Bloqueada",
	},
	statusDescription: {
		available: "Mesas disponíveis para serem abertas",
		inService1: "Mesas com atendimento iniciado.",
		inService2: "Mesas sem interações por mais de:",
		inPayment: "Mesas que já iniciaram o pagamento.",
		blocked: "Mesas bloqueadas para reserva ou por inatividade.",
	},
	minutes: "minutos",
	emptyState: {
		title: "Nenhuma mesa encontrada",
		subtitle: "Não há mesas disponíveis com os filtros selecionados.",
	},
	form: {
		minutes: {
			required: "O campo minutos é obrigatório",
			placeholder: "Digite um valor de 1 a 120",
		},
		submit: "Salvar alterações",
		successMessage: "Configurações salvas com sucesso",
	},
	updateTimeLabel: "Hora de atualização",
	updateTimeValue: "Atualizado em {{date}} às {{time}}",
	attendanceManagementAlert: {
		title: "Ainda sem evento aberto",
		message:
			"A operação será iniciada após a abertura do evento e você poderá acompanhar os status das mesas.",
		openEvent: "Abrir evento",
	},
};

export type AttendanceManagementTranslations = typeof ATTENDANCE_MANAGEMENT_PT_BR;
